module.exports = __webpack_public_path__ + "static/media/A_iko_2_kontrast_active_kontrast.e8d77fba.svg";